import React, { useState } from "react";
import { jsPDF } from "jspdf";
import NewNameRegistration from "./NewNameRegistration";
import "./NameRegistration.css";

const NameRegistration = () => {
  const [search, setSearch] = useState("");
  const [data, setData] = useState([]);
  const [showForm, setShowForm] = useState(false);

  const filteredData = data.filter((item) =>
    (item.name || "").toLowerCase().includes(search.toLowerCase())
  );

  const deleteRow = (id) => {
    if (window.confirm("Delete करायचं आहे का?")) {
      setData(data.filter((item) => item.id !== id));
    }
  };

  const generatePDF = async (specificId = null) => {
    try {
      const pdf = new jsPDF("p", "mm", "a4");
      const pageWidth = pdf.internal.pageSize.getWidth();
      
      pdf.setFillColor(79, 131, 163);
      pdf.rect(0, 0, pageWidth, 15, "F");
      pdf.setTextColor(255, 255, 255);
      pdf.setFontSize(16);
      pdf.text("नाव नोंदणी", pageWidth / 2, 10, { align: "center" });
      
      pdf.setTextColor(0, 0, 0);
      pdf.setFontSize(10);
      pdf.text(`तारीख: ${new Date().toLocaleDateString("en-GB")}`, 15, 25);
      
      const exportData = specificId 
        ? data.filter(item => item.id === specificId)
        : data;
      
      const tableData = exportData.map((item, index) => [
        index + 1,
        item.name || "",
        item.spouseName || "",
        item.mobile || ""
      ]);
      
      pdf.autoTable({
        head: [["अ.क्र.", "नागरिकाचे नाव", "पत्नीचे नाव", "संपर्क"]],
        body: tableData,
        startY: 32,
        theme: "grid",
        headStyles: {
          fillColor: [241, 244, 255],
          textColor: [44, 62, 80],
          fontStyle: "bold",
          fontSize: 11
        },
        bodyStyles: {
          textColor: [73, 80, 87],
          fontSize: 10
        },
        alternateRowStyles: {
          fillColor: [248, 249, 250]
        }
      });
      
      const pageCount = pdf.internal.pages.length - 1;
      for (let i = 1; i <= pageCount; i++) {
        pdf.setPage(i);
        pdf.setFontSize(9);
        pdf.setTextColor(128, 128, 128);
        pdf.text(`पृष्ठ ${i} / ${pageCount}`, pageWidth / 2, pdf.internal.pageSize.getHeight() - 10, { align: "center" });
      }
      
      const fileName = specificId ? `नाव-नोंदणी-${specificId}.pdf` : `नाव-नोंदणी-यादी.pdf`;
      pdf.save(fileName);
    } catch (error) {
      alert("PDF तयार करताना त्रुटी: " + error.message);
    }
  };

  const handleAddNew = () => {
    setShowForm(true);
  };

  const handleSaveNew = (newData) => {
    setData([...data, { id: Date.now(), ...newData }]);
    setShowForm(false);
    alert("नाव यशस्वीरित्या जतन झाले! ✅");
  };

  const handleBack = () => {
    setShowForm(false);
  };

  const handleImportUpdate = () => {
    alert("Import Update Data Excel feature येथे येईल");
  };

  const handleImportNew = () => {
    alert("Import New Data Excel feature येथे येईल");
  };

  const handleExport = () => {
    alert("Export Excel feature येथे येईल");
  };

  return (
    <>
      {showForm ? (
        <NewNameRegistration onSave={handleSaveNew} onBack={handleBack} />
      ) : (
        <div className="name-registration-container">
        <div className="header">नवीन नाव नोंदणीची यादी</div>

        {/* Buttons */}
        <div className="top-bar">
          <button className="btn btn-blue" onClick={handleAddNew}>
            नवीन नाव नोंदणी
          </button>
          <button className="btn btn-blue" onClick={handleImportUpdate}>
            Import Update Data Excel
          </button>
          <button className="btn btn-blue" onClick={handleImportNew}>
            Import New Data Excel
          </button>
          <button className="btn btn-green" onClick={handleExport}>
            Export Excel
          </button>
        </div>

        {/* Search */}
        <div className="search-box">
          <div className="search-field">
            <b>नाव</b>
            <br />
            <input
              placeholder="निवडा"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
          </div>

          <div className="search-field">
            <b>एकूण नाव नोंदी :</b> {filteredData.length}
          </div>

          <button className="btn btn-blue">शोधा</button>
          <button className="btn btn-blue" onClick={() => setSearch("")}>
            संपूर्ण यादी
          </button>
        </div>

        {/* Table */}
        <div className="table-header">
          <h3>नाव नोंदणी यादी</h3>
          <div className="pdf-buttons">
            <button className="btn-pdf-all" onClick={() => generatePDF()}>
              📄 सर्व PDF
            </button>
          </div>
        </div>
        <table className="data-table">
          <thead>
            <tr>
              <th>नागरिकाचे नाव</th>
              <th>पत्नीचे नाव</th>
              <th>मोबाईल नं.</th>
              <th>वारसदाराचे नाव</th>
              <th>आधार क्रमांक</th>
              <th>पॅन कार्ड क्रमांक</th>
              <th>क्रिया</th>
            </tr>
          </thead>
          <tbody>
            {filteredData.length > 0 ? (
              filteredData.map((row) => (
                <tr key={row.id}>
                  <td>{row.name}</td>
                  <td>{row.spouseName}</td>
                  <td>{row.mobile}</td>
                  <td>{row.heirName}</td>
                  <td>{row.aadhar}</td>
                  <td>{row.pan}</td>
                  <td className="action-btns">
                    <button className="btn btn-blue">Edit</button>
                    <button
                      className="btn btn-red"
                      onClick={() => deleteRow(row.id)}
                    >
                      Delete
                    </button>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="7" style={{ textAlign: "center", padding: "20px" }}>
                  <b>कोणती नोंदी उपलब्ध नाही</b>
                </td>
              </tr>
            )}
          </tbody>
        </table>
        </div>
      )}
    </>
  );
};

export default NameRegistration;
